module.exports = __webpack_public_path__ + "img/joao_sobral.869d91db.jpg";